<template>
  <div>
  <vx-card :title="'Manage Password'" no-shadow>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickPasswordChange)" autocomplete="off">
        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <div class="relative">
              <ValidationProvider vid="old_password" name="old_password" rules="required" v-slot="{ errors }">
                <small class="label">Old Password</small>
                <vs-input :type="showPassword ? 'text' : 'password'" name="old_password" class="w-full"
                  v-model="old_password" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
                <div @click.stop="showPassword = !showPassword"
                  class="flex items-center text-gray-500 focus:outline-none show-button"
                  :class="{ 'mt-3': !errors[0] }">
                  <span v-if="showPassword">
                    <img class="float-right" src="@/assets/images/pages/login/hidden.png" width="16px" height="16px" />
                  </span>
                  <span v-else>
                    <img class="float-right" src="@/assets/images/pages/login/show.png" width="16px" height="16px" />
                  </span>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <div class="relative">
              <ValidationProvider vid="password" name="password"
                rules="required|no_whitespace|one_uppercase|one_lowercase|one_number|one_special|min:8"
                v-slot="{ errors }">
                <small class="label">New Password</small>
                <vs-input :type="showNewPassword ? 'text' : 'password'" name="password" class="w-full"
                  v-model="password" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
                <div @click.stop="showNewPassword = !showNewPassword"
                  class="flex items-center text-gray-500 focus:outline-none show-button"
                  :class="{ 'mt-3': !errors[0] }">
                  <span v-if="showNewPassword">
                    <img class="float-right" src="@/assets/images/pages/login/hidden.png" width="16px" height="16px" />
                  </span>
                  <span v-else>
                    <img class="float-right" src="@/assets/images/pages/login/show.png" width="16px" height="16px" />
                  </span>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <div class="relative">
              <ValidationProvider vid="password_confirmation" name="password_confirmation"
                rules="same_password:@password" v-slot="{ errors }">
                <small class="label">Confirm Password</small>
                <vs-input :type="showPasswordConfirmation ? 'text' : 'password'" name="password_confirmation"
                  class="w-full" v-model="password_confirmation" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
                <div @click.stop="showPasswordConfirmation = !showPasswordConfirmation"
                  class="flex items-center text-gray-500 focus:outline-none show-button"
                  :class="{ 'mt-3': !errors[0] }">
                  <span v-if="showPasswordConfirmation">
                    <img class="float-right" src="@/assets/images/pages/login/hidden.png" width="16px" height="16px" />
                  </span>
                  <span v-else>
                    <img class="float-right" src="@/assets/images/pages/login/show.png" width="16px" height="16px" />
                  </span>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

  <vx-card :title="'Manage MFA Security'" class="mt-2" no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="mfa-setup-form" @submit.prevent="handleSubmit(setupMFA)" autocomplete="off">
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <div class="mb-3">
                <small class="label">MFA Status</small>
                <vs-input name="mfaStatus" class="w-1/2" readonly v-model="mfaStatus" />
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/3">
              <div v-if="current_user.is_google_2fa_enable" class="flex flex-col">
                <small class="label">Reset/Sync MFA with M-Hub</small>
                <div>
                  <vs-button color="primary" type="filled" @click="resetMFA()" icon-pack="feather" class="ml-2 mt-1">
                    Reset/Sync MFA
                  </vs-button>
                </div>
              </div>
              <div v-if="current_user.is_google_2fa_enable == false" class="flex flex-col">
                <small class="label">Setup MFA with Nimble</small>
                <div>
                  <vs-button color="primary" type="filled" @click="resetMFA()" icon-pack="feather" class="ml-2 mt-1">
                    Setup MFA
                  </vs-button>
                </div>
              </div>
            </div>
            <div v-if="showMFAReset" class="vx-col w-1/3">
              <div class="flex flex-col ">
                <small>1 . Scan QR Code</small>
                <div class="mt-2"
                  style="background:#ffffff; display:inline-block; vertical-align:middle; height: fit-content; width: fit-content;">
                  <div style="background:#ffffff; display:inline-block;">
                    <img width="200" v-bind:src="qrForm.google_2fa_url"/>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showMFAReset" class="vx-col w-1/3">
              <ValidationProvider vid="name" name="name" rules="required|min:6|max:6" v-slot="{ errors }">
                <small class="label">2 . Enter Authentication Code</small>
                <vs-input class="w-1/2 mt-1" v-model="verification_code" name="name" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
              <div class="flex flex-wrap">
                <vs-button button="submit" class="mt-2">Confirm</vs-button>
                <vs-button @click="onClickClear()" class="mt-2 ml-4" type="border" color="warning">Clear</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import profile from '@/apis/profile.js'
const StaffRepository = RepositoryFactory.get('staff');
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  mixins: [SuccessMessage, ErrorMessages],
  data() {
    return {
      old_password: '',
      password: '',
      password_confirmation: '',
      showPassword: false,
      showNewPassword: false,
      showPasswordConfirmation: false,
      showMFAReset: false,
      qrForm :{},
      current_user : {is_google_2fa_enable:false},
      mfaStatus : "Disabled",
      verification_code : ""
    }
  },
  computed: {},
  async mounted() {
    await this.getCurrentUser()
  },
  methods: {
    async getCurrentUser() {
      this.$vs.loading()
      const {data} =  await profile.getCurrentUser()
      this.current_user = data.data
      this.mfaStatus = this.current_user.is_google_2fa_enable ? "Enabled":"Disabled";
      this.$vs.loading.close()
    },
    async onClickPasswordChange() {
      this.$vs.loading();
      try {
        const change = await StaffRepository.passwordChange({
          'old_password': this.old_password,
          'password': this.password,
          'password_confirmation': this.password_confirmation
        });
        this.showSuccessMessage('Password changed successfully!')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.clearFormData()
      this.$refs.form.reset();
      this.$vs.loading.close()
    },
     async get2FAQRCode() {
      await this.$vs.loading({
        container: '#mfa-setup-form',
        scale: 0.45
      })
      try {
        const {data} = (await StaffRepository.get2FAQRCode(this.current_user.id)).data
        this.qrForm = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#mfa-setup-form > .con-vs-loading')
    },
    clearFormData() {
      this.password = '';
      this.old_password = '';
      this.password_confirmation = '';
    },
    resetMFA(){
      this.showMFAReset = !this.showMFAReset;
      if(this.showMFAReset == true){
        this.get2FAQRCode()
      }
    },
    async setupMFA(){
      const vue = this;
      await this.$vs.loading({
        container: '#mfa-setup-form',
        scale: 0.45
      })
      try {
        await StaffRepository.enable2FA({ secret: this.verification_code }, this.current_user.id);
        this.showSuccessMessage('2FA enabled successfully');
        this.$emit('refreshData')
        this.mfaStatus = 'Enabled'
        this.showMFAReset = false;
        this.verification_code = "";
      } catch (e) {
        this.$vs.loading.close('#mfa-setup-form > .con-vs-loading')
        this.verification_code = "";
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#mfa-setup-form > .con-vs-loading')
    },
    onClickClear(){
      this.verification_code = ""
    }
  },
}
</script>

<style scoped>
.show-button {
  background: none;
  border: none;
  cursor: pointer;
  align-content: right;
  padding: 0;
  background: none;
  border: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
}
</style>